"use client";

import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reservas() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const [isPulsing, setIsPulsing] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsPulsing(prev => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  return <section id="reservas" className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20 overflow-hidden bg-secondary">
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(135deg, hsla(17, 70%, 48%, 0.05) 0%, hsla(220, 57%, 24%, 0.05) 100%)"
    }} />

      {}
      <div className="relative z-10 max-w-4xl mx-auto text-center space-y-8">
        {}
        <h2 ref={headlineRef} className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-primary transition-all duration-slow ease-smooth ${headlineVisible ? "opacity-100 tracking-wide" : "opacity-0 tracking-[0.5em]"}`} style={{
        transitionDuration: "var(--duration-slow)",
        transitionTimingFunction: "var(--ease-smooth)"
      }}>
          Reservas
        </h2>

        <p className="text-foreground-dark text-lg md:text-xl max-w-2xl mx-auto opacity-90">
          Asegura tu lugar en una experiencia culinaria inolvidable. Reserva ahora y disfruta de nuestra cocina excepcional.
        </p>

        {}
        <div ref={buttonRef} className={`transition-all duration-medium ease-smooth ${buttonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:border-accent border-transparent border-[1px] shadow-[0_6px_0_0_rgba(0,0,0,0.15)] hover:shadow-medium hover:-translate-y-0.5 hover:scale-[1.05] active:bg-primary-active active:translate-y-0 active:scale-100 transition-all duration-fast ease-[var(--ease-spring)] px-10 py-6 text-base md:text-lg font-semibold rounded-md">
            <Link to="#" className="inline-flex items-center gap-2">
              Hacer una Reserva
            </Link>
          </Button>
        </div>
      </div>

      {}
      <Link to="https://wa.me/" newTab className="fixed bottom-8 right-8 z-50 flex items-center justify-center size-14 md:size-16 bg-accent rounded-full shadow-strong hover:shadow-[0_16px_32px_rgba(0,0,0,0.2)] hover:scale-110 transition-all duration-medium ease-[var(--ease-out-back)] group" aria-label="Contactar por WhatsApp">
        <MessageCircle className={`text-foreground-accent size-7 md:size-8 transition-transform duration-medium ${isPulsing ? "scale-110" : "scale-100"}`} />
        <span className="sr-only">Contactar por WhatsApp</span>
      </Link>
    </section>;
}